import React from 'react';
import { BadgePercentIcon, HandshakeIcon, TargetIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
const principles: {
  title: string;
  body: string;
  icon: typeof HandshakeIcon;
}[] = [{
  title: 'The retainer means something',
  icon: HandshakeIcon,
  body: 'Month to month, no annual contract. If we stop producing, you stop paying. We priced our own failure into the deal and put the guarantee in writing.'
}, {
  title: 'We never touch your commission',
  icon: BadgePercentIcon,
  body: 'No per-lead fees, no per-minute meters, no percentage of your deals. Vendors who take a cut of closings have opinions about your leads. Yours are 100% yours.'
}, {
  title: 'We know where deals stall',
  icon: TargetIcon,
  body: 'Kevin Rogers spent two years at Zillow as a Senior Elite Account Executive. He watched great agents lose to faster ones and knows exactly how the scorecard rewards the teams that answer first.'
}];
export function Principles() {
  return <section id="principles" aria-label="How Viridia operates" className="border-b border-white/5 bg-ink-800" data-id="element-170" data-mp="yusjsv5991bw">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-171" data-mp="tyu0vn2p4biv">
        <ul className="grid gap-5 md:grid-cols-3" data-id="element-172" data-mp="p4pqetu81ld1">
          {principles.map((item, index) => {
          const Icon = item.icon;
          return <li key={item.title} className="h-full" data-id="element-173" data-mp="g52swj4m4zp9" data-mpi={index}>
                <Reveal delay={0.06 * index} className="h-full" data-id="element-174" data-mp="g6nmo6j3sem2">
                  <div className="flex h-full flex-col rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-175" data-mp="b57zo8xd7y11">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-176" data-mp="687vk3k2t5ck">
                      <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-177" data-mp="27e7na6mvqjo" />
                    </span>
                    <h2 className="mt-6 font-display text-lg font-semibold tracking-tight text-white" data-id="element-178" data-mp="20j3aroprniob">
                      {item.title}
                    </h2>
                    <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-179" data-mp="3q1jfcfqxtyzn">
                      {item.body}
                    </p>
                  </div>
                </Reveal>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}